module.exports = __webpack_public_path__ + "static/img/calme_shadow.fbee6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/calme_shadow.png
// module id = /CRR
// module chunks = 0